import request from '@/utils/request.js';
// 登录平台上报（访问礼包中心、所有活动页面、游戏中心、客服调用该接口）
export const reportLoginPlatform = data =>
  request({ url: '/v1/report/platform_user_login', method: 'post', data });
// 登录论坛上报（除登录平台上报接口外其他页面调用该接口）
export const reportLoginForum = data =>
  request({ url: '/v1/report/forum_user_login', method: 'post', data });
// 页面埋点数据上报
export const reportData = data => request({ url: '/v1/report/data', method: 'post', data });
// 页面埋点数据异步上报
export const reportDataSync = data => request({ url: '/v1/report_data/async', method: 'post', data });